import React from "react";
import { LongTextLabel, Table } from "@sscs/ui";
import { Permission } from "Constants";
import { Member } from "Types";
import { transformRoleLabel } from "Utils";
import GroupListTooltip from "../GroupListTooltip/GroupListTooltip";
import MemberLoginStatus from "../MemberLoginStatus/MemberLoginStatus";
import MemberName from "../MemberName/MemberName";
import MemberRowActions from "./MemberRowActions";

type MemberRowProps = {
  member: Member;
  permissions: Permission[];
  groupId?: string;
};

const MemberRow = ({
  member,
  groupId,
  permissions,
}: MemberRowProps): React.JSX.Element => {
  return (
    <>
      <Table.Row hover>
        <Table.Cell>
          <MemberName member={member} />
        </Table.Cell>
        <Table.Cell>
          <LongTextLabel label={member.email} />
        </Table.Cell>
        <Table.Cell>{transformRoleLabel(member, groupId)}</Table.Cell>
        <Table.Cell>
          <GroupListTooltip
            groups={member.org_groups?.map((group) => group.name) ?? []}
          />
        </Table.Cell>
        <Table.Cell>
          <MemberLoginStatus
            status={member.status}
            last_active={member.last_active}
          />
        </Table.Cell>
        <MemberRowActions
          groupId={groupId}
          member={member}
          permissions={permissions}
        />
      </Table.Row>
    </>
  );
};

export default MemberRow;
